import { graphql } from '@/lib/query'
import ImageFragment from '../image'

const PartnerFragment = graphql(
  /* GraphQL */ `
    fragment PartnerFragment on PartnerRecord @_unmask {
      logo {
        ...ImageFragment
      }
      name
      link
      description
      linkText
    }
  `,
  [ImageFragment]
)

export default PartnerFragment
